module.exports = __webpack_public_path__ + "img/slider.8555344c.png";